/**
 * PLAT-AUTH-UI-ONE-3 (H1) — the brand identity the shared sign-in screen
 * (pages/Login.tsx) shows, from this app's brand mechanism (BrandProvider:
 * ?brand= / subdomain, then GET /api/brand/{key} from brands.yaml).
 *
 * null = the default Yansar brand: Login renders exactly as it always has.
 * Any other brand gets its own name and colours and never a Yansar value;
 * footer and contact address show only when the brand supplies them.
 *
 * OTCID's generated copy of Login imports this from its adapter instead
 * (apps/otcid_react/src/auth/adapter.ts), which reads OTCID's BrandContext.
 */
import { useBrand } from './BrandProvider'
import type { SignInBrand } from '@/types'

export function useSignInBrand(): SignInBrand | null {
  const { brandKey, theme } = useBrand()
  if (brandKey === 'yansar') return null
  const extra = theme as Partial<{ footerCopyright: string; contactEmail: string }>
  return {
    name: theme.name ?? '',
    logoUrl: null,
    primaryColor: theme.primaryColor || null,
    accentColor: theme.accentColor || null,
    footer: extra.footerCopyright || null,
    contactEmail: extra.contactEmail || null,
  }
}
